import React, { useEffect, useLayoutEffect, useState, useRef } from "react";
import { useFormik } from "formik";
import userService from "../services/user.service";
import { Uservalidationschema } from "../components/Validation";
import ReactPaginate from "react-paginate";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import { format } from "date-fns";
import Loader from "../components/Loader";
import Toastmessage from "../components/Toastmessage";
import { useNavigate, Link } from "react-router-dom";
import Alertmsg from "../components/Alertmsg";
const Usersmarttableinlineform = () => {
  const ref = useRef();
  let navigate = useNavigate();

  const [isLoaded, setIsLoaded] = useState(false);
  const [ismessage, setIsmessage] = useState("");
  const [eventname, setEventname] = useState("create");

  const [users, setUsers] = useState([]);
  const [result, setResult] = useState([]);
  //smart table data
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(5);
  const [filter, setFilter] = useState("");
  const [search, setSearch] = useState("");
  const [between, setBetween] = useState("");
  const [sort, setSort] = useState("");
  const [group, setGroup] = useState("");

  const [pagecount, setPagecount] = useState("");
  const [resultCount, setResultcount] = useState("");

  //table header arrays
  const tableHeaders = [
    { label: "user ID", value: "" },
    { label: "user name", value: "user_name" },
    { label: "Status", value: "user_status" },
    { label: "actions", value: "" },
  ];
  //filter arrays
  const statusfilterarr = [
    { status_id: "01", status_name: "pending" },
    { status_id: "02", status_name: "active" },
    { status_id: "03", status_name: "inactive" },
  ];
  const [filterarray, setFilterarray] = useState(statusfilterarr);
  //date range
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const selectionRange = {
    startDate: startDate,
    endDate: endDate,
    key: "selection",
  };
  //form initial value
  const formik = useFormik({
    initialValues: {
      user_id: "",
      user_name: "",
      user_status: "",
    },
    validationSchema: Uservalidationschema,
    /*  validateOnChange: false,
         validateOnBlur: false, */
    onSubmit: (values, { resetForm }) => {
      /* resetForm({ values: "" }); */
    },
  });
  //use effects
  useEffect(() => {
    getallUser();
  }, []);
  useLayoutEffect(() => {
    getallUser();
  }, [page, limit, filter, search, between, sort]);

  //current event
  const userEvent = (eventname, value) => {
    if (value != "") {
      getUser(value);
      setEventname(eventname);
    }
    setEventname(eventname);
    formik.resetForm();
  };
  //get alluser
  const getallUser = async () => {
    setIsLoaded(true);
    var data = {
      limit: limit,
      page: page,
      filter: filter,
      search: search,
      between: between,
      sort: sort,
      group: group,
    };
    return await userService
      .getallUser(data)
      .then((res) => {
        if (res.data.result) {
          setIsLoaded(false);
          setUsers(res.data.result.data);
          setResult(res.data);
          setPage(res.data.result.page);
          setLimit(res.data.result.limit);
          setPagecount(res.data.result.pagecount);
          setResultcount(res.data.result.resultcount);
          console.log(res.data);
        } else {
          setIsLoaded(false);
          setUsers(null);
        }
      })
      .catch((err) => {
        setIsLoaded(false);
        setIsmessage(err.message);
      });
  };
  //pagination
  const paginationfn = (event) => {
    setPage(event.selected + 1);
    console.log(event.selected + 1);
  };
  //search
  const searchfn = (e) => {
    setPage(1);
    setSearch(e.target.value);
  };
  //filter
  const [filterArr, setfilterArr] = useState([]);
  const filterfn = (value) => {
    setPage(1);
    var index = filterArr.indexOf(value);
    if (index > -1) {
      filterArr.splice(index, 1);
      setFilter(filterArr.toString());
    } else {
      filterArr.push(value);
      setFilter(filterArr.toString());
    }
  };
  //sort
  const sortfn = (value) => {
    /*    setSort(value); */
    if (sort == value + " desc") {
      setSort(value + " asc");
      console.log(value + " asc");
    } else if (sort == value + " asc") {
      setSort("");
      console.log(value + "");
    } else {
      setSort(value + " desc");
      console.log(value + " desc");
    }
  };
  const betweenfn = async (date) => {
    await setStartDate(date.selection.startDate);
    await setEndDate(date.selection.endDate);
    setBetween(
      format(date.selection.startDate, "yyyy-MM-dd") +
        " , " +
        format(date.selection.endDate, "yyyy-MM-dd")
    );
  };
  //between
  const resetbetweenfn = () => {
    setBetween("");
    setStartDate(new Date());
    setEndDate(new Date());
  };
  const resetfilterfn = () => {
    setFilter("");
  };
  //get user
  const getUser = (value) => {
    setIsLoaded(true);
    userService
      .getUser(value)
      .then((res) => {
        if (res.data.result) {
          console.log(res.data);
          setIsLoaded(false);
          let data = res.data.result;
          formik.setValues({
            user_id: data.user_id,
            user_name: data.user_name,
            user_status: data.user_status,
          });
        } else {
          setIsLoaded(false);
        }
      })
      .catch((err) => {
        setIsLoaded(false);
        setIsmessage(err.message);
      });
  };
  //create user
  const createUser = () => {
    setIsLoaded(true);
    userService
      .createUser(formik.values)
      .then((res) => {
        if (res.data.status) {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
          setEventname("create");
          getallUser();
        } else {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
        }
      })
      .catch((err) => {
        setIsLoaded(false);
        setIsmessage(err.message);
      });
  };

  //update user
  const updateUser = (value) => {
    console.log(JSON.stringify(formik.values, null, 2));
    userService
      .updateUser(formik.values)
      .then((res) => {
        if (res.data.status) {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
          setEventname("view");
          getallUser();
        } else {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
        }
      })
      .catch((err) => {
        setIsLoaded(false);
        setIsmessage(err.message);
      });
  };
  //delete user
  const deleteUser = (value) => {
    console.log(value);
    userService
      .deleteUser(String(value))
      .then((res) => {
        if (res.data.status) {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
          setEventname("create", "");
          formik.resetForm();
          getallUser();
        } else {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
        }
      })
      .catch((err) => {
        setIsLoaded(false);
        setIsmessage(err.message);
      });
  };
  const selectedcolor = (value) => {
    if (value === "active") {
      return "badge rounded-pill bg-success";
    } else if (value === "pending") {
      return "badge rounded-pill bg-warning ";
    } else if (value === "inactive") {
      return "badge rounded-pill bg-danger";
    } else {
      return "badge rounded-pill bg-dark";
    }
  };
  // Call user clicks to request another page.
  if (ismessage == "Network Error") {
    return <Alertmsg alertmsg={ismessage} type={false} />;
  }
  return (
    <div className="">
      <div className="">
        {/*  loader and error handler */}
        {<Toastmessage ref={ref} />}
        {isLoaded ? <Loader /> : <></>}
      </div>
      {/*  container */}
      <div className="user-container">
        {/* tebale header part search,filter,sort */}
        <div className="d-md-flex  mb-2 ">
          {/* create user */}
          {/*  <div className="m-1">
            <button
              onClick={() => {
                setEventname("create", "");
                formik.handleReset();
              }}
              type="submit"
              className="btn btn-primary  w-100"
            >
              <i className="fa fa-plus-circle"></i> New
            </button>
          </div> */}
          {/* filter status*/}
          <div className="dropdown m-1">
            <button
              className="btn btn-primary w-100 dropdown-toggle"
              type="button"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="fa fa-filter" aria-hidden="true"></i> Filter
            </button>
            <ul
              style={{ minWidth: 200 }}
              className="dropdown-menu p-2"
              aria-labelledby="dropdownMenuButton1"
            >
              <li className="text-secondary">User Status</li>
              {filterarray.map((filterdata, index) => (
                <li key={index}>
                  <div className="form-check">
                    <input
                      onChange={(e) => filterfn(filterdata.status_name)}
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckDefault"
                    ></input>
                    <label
                      className="form-check-label text-dark"
                      htmlFor="flexCheckDefault"
                    >
                      {filterdata.status_name}
                    </label>
                  </div>
                </li>
              ))}
              <li></li>
            </ul>
          </div>
          {/* search */}
          <div className=" m-1">
            <input
              className="form-control"
              onChange={searchfn}
              placeholder="search"
              type="search"
            ></input>
          </div>
          {/*  date range  */}
          <div className="m-1 ms-auto">
            <div className="btn-group" role="group">
              {between ? (
                <button
                  type="button"
                  className="btn bg-white border me-1 "
                  onClick={resetbetweenfn}
                >
                  <i className="fa fa-times" aria-hidden="true"></i>
                </button>
              ) : (
                <></>
              )}
              <button
                className="btn bg-white border dropdown-toggle"
                id="dropdownMenuClickableInside"
                data-bs-toggle="dropdown"
                data-bs-auto-close="outside"
                aria-expanded="false"
              >
                <i className="fa fa-calendar" aria-hidden="true"></i> {between}
              </button>
              <ul
                className="dropdown-menu"
                aria-labelledby="dropdownMenuClickableInside"
              >
                <li className="">
                  <DateRangePicker
                    ranges={[selectionRange]}
                    onChange={(date) => betweenfn(date)}
                  />
                </li>
                <li className="text-end">
                  <a onClick={resetbetweenfn} className="btn">
                    Reset
                  </a>
                  {/*  <a data-bs-dismiss="dropdown"  className="btn">Okay</a> */}
                </li>
              </ul>
            </div>
          </div>
          {/* between */}
        </div>
        {/* table section*/}
        <div className="table-responsive card bg-white border-0 mb-2">
          <form onSubmit={formik.handleSubmit}>
            <table className="table table-striped table-hover">
              <thead>
                <tr>
                  {tableHeaders.map((data, index) => (
                    <th key={index} scope="col">
                      {data.label}
                      {/* table sort */}
                      {data.value != "" ? (
                        <a
                          onClick={() => sortfn(data.value)}
                          className="btn btn-sm"
                        >
                          <span
                            className={
                              sort === data.value + " asc"
                                ? "text-dark"
                                : "text-secondary"
                            }
                          >
                            {" "}
                            <i className="fa fa-long-arrow-up"></i>
                          </span>
                          <span
                            className={
                              sort === data.value + " desc"
                                ? "text-dark"
                                : "text-secondary"
                            }
                          >
                            <i className="fa fa-long-arrow-down"></i>
                          </span>
                        </a>
                      ) : (
                        <></>
                      )}
                    </th>
                  ))}
                  {/* <th scope="col">#</th>
                <th scope="col">user name</th>
                <th scope="col">Status</th>
                <th style={{ width: 100 }} scope="col">
                  Action
                </th> */}
                </tr>
                <tr>
                  <td>
                    <div className="input-group">
                      <input
                        className="form-control"
                        placeholder="Enter User ID"
                        id="user_id"
                        type="text"
                        disabled={
                          eventname == "view"
                            ? true
                            : eventname == "delete"
                            ? true
                            : false
                        }
                        {...formik.getFieldProps("user_id")}
                      />
                    </div>
                    <div>
                      {formik.touched.user_id && formik.errors.user_id ? (
                        <div className="error">{formik.errors.user_id}</div>
                      ) : null}
                    </div>
                  </td>
                  <td>
                    <div className="input-group">
                      <input
                        className="form-control"
                        placeholder="Enter Username"
                        id="user_name"
                        type="text"
                        disabled={
                          eventname == "view"
                            ? true
                            : eventname == "delete"
                            ? true
                            : false
                        }
                        {...formik.getFieldProps("user_name")}
                      />
                    </div>
                    <div>
                      {formik.touched.user_name && formik.errors.user_name ? (
                        <div className="error">{formik.errors.user_name}</div>
                      ) : null}
                    </div>
                  </td>
                  <td>
                    <div className="input-group">
                      <select
                        id="user_status"
                        {...formik.getFieldProps("user_status")}
                        className="form-select"
                        aria-label="user_status"
                        disabled={
                          eventname == "view"
                            ? true
                            : eventname == "delete"
                            ? true
                            : false
                        }
                      >
                        <option value="" disabled>
                          Select status
                        </option>
                        <option value="pending">Pending</option>
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                      </select>
                    </div>
                    <div>
                      {formik.touched.user_status &&
                      formik.errors.user_status ? (
                        <div className="error">{formik.errors.user_status}</div>
                      ) : null}
                    </div>
                  </td>
                  <td>
                    {/*  event button */}
                    <div style={{ minWidth: 160 }} className="">
                      {eventname === "create" ? (
                        <>
                          <button
                            disabled={!formik.isValid || !formik.dirty}
                            onClick={() => createUser()}
                            className="btn btn-primary me-2"
                          >
                            Create
                          </button>
                          <button
                            disabled={!formik.dirty}
                            onClick={formik.handleReset}
                            className="btn btn-secondary"
                          >
                            Clear
                          </button>
                        </>
                      ) : eventname === "edit" ? (
                        <>
                          <button
                           disabled={!formik.isValid || !formik.dirty}
                            onClick={() => updateUser()}
                            className="btn btn-primary me-2"
                          >
                            Update
                          </button>
                          <button
                            disabled={!formik.dirty}
                            onClick={() => {
                              userEvent("create", "");
                              formik.handleReset();
                            }}
                            className="btn btn-secondary"
                          >
                            Cancel
                          </button>
                        </>
                      ) : eventname === "delete" ? (
                        <>
                          <button
                            onClick={() => deleteUser(formik.values.user_id)}
                            className="btn btn-danger me-2 "
                          >
                            Delete
                          </button>
                          <button
                            disabled={!formik.dirty}
                            onClick={() => {
                              userEvent("create", "");
                              formik.handleReset();
                            }}
                            className="btn btn-secondary"
                          >
                            Cancel
                          </button>
                        </>
                      ) : (
                        <>
                          <button
                            onClick={() => {
                              userEvent("create", "");
                              formik.handleReset();
                            }}
                            className="btn btn-primary"
                          >
                            Close
                          </button>
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              </thead>
              <tbody>
                {/* table data */}
                {users ? (
                  <>
                    {users.map((data, index) => (
                      <tr key={index}>
                        <td>{data.user_id}</td>
                        <td>{data.user_name}</td>
                        <td>
                          <span className={selectedcolor(data.user_status)}>
                            {data.user_status}
                          </span>
                        </td>
                        {/*  <td>{format(new Date(data.createdAt), "PPpp")}</td> */}
                        <td className="p-1 m-0">
                          <button
                            onClick={() => userEvent("view", data.user_id)}
                            className="btn btn-light me-2 "
                          >
                            <i className="fa fa-eye" aria-hidden="true"></i>
                          </button>
                          <button
                            onClick={() => userEvent("edit", data.user_id)}
                            className="btn btn-light me-2 "
                          >
                            <i
                              className="fa fa-pencil-square"
                              aria-hidden="true"
                            ></i>
                          </button>
                          <button
                            onClick={() => userEvent("delete", data.user_id)}
                            className="btn btn-light me-2 "
                          >
                            <i className="fa fa-trash-o" aria-hidden="true"></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </>
                ) : (
                  <tr>
                    <td colSpan={6} className="text-center">
                      <div className="text-center p-3">0 data found</div>
                    </td>
                  </tr>
                )}
              </tbody>
              <caption className="">
                <div className="d-flex">
                  <div className="flex-fill"></div>
                  <div className="p-1 "> Items per page </div>
                  <div>
                    {" "}
                    <select
                      value={limit}
                      onChange={(e) => {
                        setLimit(e.target.value);
                        setPage(1);
                      }}
                      className="form-select form-select-sm"
                    >
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="20">20</option>
                    </select>
                  </div>
                  <div className="p-1 me-4">
                    {page * limit - limit}-{page * limit} of {resultCount}
                  </div>
                  <ReactPaginate
                    previousLabel="< Prev"
                    nextLabel="Next >"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    breakLabel="..."
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    pageCount={pagecount}
                    marginPagesDisplayed={3}
                    pageRangeDisplayed={3}
                    onPageChange={paginationfn}
                    containerClassName="pagination"
                    activeClassName="actives"
                    disabledLinkClassName="text-secondary"
                    forcePage={page - 1}
                  />
                </div>
              </caption>
            </table>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Usersmarttableinlineform;
